module.exports = __webpack_public_path__ + "img/converse-details1.dab9710a.png";